import { useIntl } from "react-intl";
import { useLoading } from "../../../components/LoadingContext";
import axios from "../../../api/axiosClient";
import { Modal, Box, Typography, Grid, Button } from "@mui/material";
import PageHeader from "../../ui/PageHeader";
import { errorToast, handleError } from "../../../services/serviceBase";
import toast from "react-hot-toast";
import CustomInput from "../../ui/CustomInput";
import { useRef } from "react";

const EditDestinationTriangModal = (props) => {
  const { editData } = props;
  const { jdaLocation, description, idJdaLocationDestination, idJdaLocation } =
    editData;

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 700,
    overflow: "auto",
    p: 4,
    borderRadius: "5px",
  };

  const intl = useIntl();
  const { setLoading } = useLoading();
  const newCode = useRef();
  const newDescription = useRef();

  const handleClose = (action) => {
    props.handleCloseModal(action);
  };

  const handleSave = (action) => {
    updateJDALocationDestinationDescr();
  };

  const updateJDALocationDestinationDescr = () => {
    setLoading(true);
    let data = {
        idJdaLocation,
        newCode: newCode.current.value,
        newDescription: newDescription.current.value
    };
    let url = `/creditnote/destinationtriang/${idJdaLocationDestination}`;
    axios
      .put(url, data)
      .then(() => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "General.Saved" }));
        handleClose()
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader
          title={intl.formatMessage({
            id: "General.Edit",
          })}
        />
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item lg={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "NdCDestinationTriang.Code",
              })}
              type="text"
              valueRef={newCode}
              defaultValue={props.editData.code}
              textCol={2}
              inputCol={10}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "NdCDestinationTriang.Description",
              })}
              type="text"
              valueRef={newDescription}
              defaultValue={props.editData.description}
              textCol={2}
              inputCol={10}
            />
          </Grid>
        </Grid>
        <Box sx={{ background: "#bcb7b7", color: "white", mt: 2 }}>
          <Grid container>
            <div style={{ margin: "auto" }}></div>
            <Grid item xs="auto" textAlign="center">
              <Button sx={{ color: "white" }} onClick={handleClose}>
                [{intl.formatMessage({ id: "General.Cancel" })}]
              </Button>
            </Grid>
            <Grid item xs="auto" textAlign="center">
              <Button sx={{ color: "white" }} onClick={handleSave}>
                [{intl.formatMessage({ id: "General.Save" })}]
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditDestinationTriangModal;
